/**
 * The Donate Form drops a cookie when a donation has been started - see AbandonedDonationNotificationManager
 * 
 * If the donor does not complete the donation and returns to the charity/fundraising/campaign page, 
 * the cookie is used to trigger a message to the user, prompting them to complete their donation
 * 
 * Purpose of this class is to send the analytics event and to delete the cookie if the user hides the notification
 * 
 * The class requires the notification element to exist - see abandoned-donation-notification.vm, 
 * the element will only be rendered when it should be shown (based on cookie and any A/B tests)
 */

import AbandonedDonationNotificationManager from 'Scripts/donate-form/abandoned-donation-notification-manager';
import AnalyticsEvent from 'Scripts/common/analytics-event';

export default class AbandonedDonationNotification {
	constructor(opts) {
		this.notification = $("#abandoned-donation-notification");

		// Stop if the notification element does not exist
		if(!this.notification.length) {
			return
		}

		this.manager = new AbandonedDonationNotificationManager({
			type: this.notification.data('type'),
			id: this.notification.data('id'),
		});

		this.bindEvents();

		AnalyticsEvent.heap('AbandonedDonationNotificationShown');
	}

	bindEvents() {
		$(".js-hide-abandoned-donation-notification").on("click", this.onHideNotification.bind(this));
	}

	onHideNotification() {
		console.log("AbandonedDonationNotification.onHideNotification");

		this.notification.hide();

		this.manager.deleteCookie()
	}
}